export class DashboardVariables {
}
DashboardVariables.CATEGORY_ORDER = [
    "Group",
    "Company",
    "Site",
    "Category",
    "Subcategory",
    "Topic",
    "Tracked Item",
];
